import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { QueryClient } from "@tanstack/react-query";
import QueryProvider from "@/components/QueryProvider";
import { AuthProvider } from "@/hooks/AuthProvider";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { FontSizeProvider } from "@/contexts/FontSizeContext";
import TokenExpirationHandler from "@/components/TokenExpirationHandler";

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <QueryProvider>
      <AuthProvider>
        <ThemeProvider>
          <FontSizeProvider>
            <TokenExpirationHandler />
            <Outlet />
          </FontSizeProvider>
        </ThemeProvider>
      </AuthProvider>
    </QueryProvider>
  ),
});
